module.exports = __webpack_public_path__ + "static/media/licencia_dorso.558f339c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/user/licencia_dorso.jpg
// module id = 354
// module chunks = 0